import config from '../../../config';

const correspondenceBaseUrl = `${config.apiUrl(1)}/CorrespondencePreferences`;

export default {
  optInWhatsApp: (): string => `${correspondenceBaseUrl}/whatsapp-opt-in`,
  optOutWhatsApp: (): string => `${correspondenceBaseUrl}/whatsapp-opt-out`,
  optOutEmail: (): string => `${correspondenceBaseUrl}/email-opt-out`,
};
